import { render, staticRenderFns } from "./HeaderSocial.vue?vue&type=template&id=575ae890&scoped=true"
import script from "./HeaderSocial.vue?vue&type=script&lang=js"
export * from "./HeaderSocial.vue?vue&type=script&lang=js"
import style0 from "./HeaderSocial.vue?vue&type=style&index=0&id=575ae890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ae890",
  null
  
)

export default component.exports